import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import {
    Message,
    Loading
} from 'element-ui';
import 'element-ui/lib/theme-chalk/message.css';
import 'element-ui/lib/theme-chalk/loading.css';
import './printer.scss';
import {
    jsBridgeForSSAI,
    isSSAI,
    getSign,
    getStamp,
    getRandom,
    getAppInfo,
    validateEmail
} from './utils';
import api from './api';
import config from './config';
var SpadPrint = function () {
    function SpadPrint(options, callback) {
        var _this = this;
        _classCallCheck(this, SpadPrint);
        this.options = options;
        this.printSerialNnum = '';
        this.printUrl = options.printUrl;
        this.changeFile = 0;
        this.sendContent = {
            'course_id': options.courseId,
            'lesson_id': options.lessonId,
            'study_card_id': options.studyCardId,
            'topic_id': options.topicId,
            'module_type': options.moduleType,
            'subject_id': options.subjectId,
            'report_name': options.reportName
        };
        var env = this.getEnv();
        this.printHost = config[env].PRINT_HOST;
        this.printKey = config[env].PRINT_KEY;
        this.isCheckingAuthorization = false;
        this.authCheckTimerId = null;
        this.isPrinting = false;
        window.authorizationResult = function (resultJson) {
            console.log(resultJson, '授权检查结果:authorizationResult');
            var result = typeof resultJson === 'string' ? JSON.parse(resultJson) : resultJson;
            if (_this.authCheckTimerId) {
                clearTimeout(_this.authCheckTimerId);
                _this.authCheckTimerId = null;
            }
            _this.isCheckingAuthorization = false;
            try {
                var isAuthorized = false;
                if (typeof result.isAuthorization === 'string') {
                    isAuthorized = result.isAuthorization === 'true';
                } else {
                    isAuthorized = result.isAuthorization === true;
                }
                if (isAuthorized) {
                    console.log('已授权\uFF0C显示打印选择框');
                    _this.showPrinterSet();
                } else {
                    console.log('未授权\uFF0C显示授权提示弹框');
                    _this.showAuthorizationDialog();
                }
            } catch (error) {
                console.error('授权检查结果解析失败\uFF0C默认显示授权弹框', error);
                _this.showAuthorizationDialog();
            }
        };
        window.printResult = function () {
            var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(json) {
                var status, msg, deviceInfo, machineType, machineSN, appInfo, postData, result;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                        case 0:
                            console.log(json, '打印结果:printResult');
                            json = JSON.parse(json);
                            if (json.data.device) {
                                localStorage.setItem('printerDeviceInfo', JSON.stringify(json.data.device));
                            }
                            status = json.status;
                            msg = '';
                            deviceInfo = {};
                            _context.t0 = status;
                            _context.next = _context.t0 === 1 ? 9 : _context.t0 === 90 ? 12 : _context.t0 === 100 ? 16 : _context.t0 === 1000 ? 18 : _context.t0 === -1 ? 21 : 25;
                            break;
                        case 9:
                            _this.hidePrinterSetDialog();
                            _this.hideSearchPrinterDialog();
                            return _context.abrupt('break', 29);
                        case 12:
                            machineType = json.data.machineType;
                            machineSN = json.data.device.device_sn || '';
                            if (machineType && machineSN) {
                                _this.changeFile = 1;
                                _this.addSearchPrinter(machineType, machineSN);
                                localStorage.setItem('machineSN', machineSN);
                                localStorage.setItem('machineType', machineType);
                                _this.isPrinting = false;
                            } else {
                                msg = '打印设备类型不正确,Type:'.concat(_this.machineType, ',SN:').concat(_this.machineSN);
                                Message.error(msg);
                                _this.isPrinting = false;
                            }
                            return _context.abrupt('break', 29);
                        case 16:
                            msg = '打印完成';
                            return _context.abrupt('break', 29);
                        case 18:
                            msg = '打印任务结束';
                            _this.isPrinting = false;
                            return _context.abrupt('break', 29);
                        case 21:
                            msg = '打印失败:' + json.error;
                            Message.error(msg);
                            _this.isPrinting = false;
                            return _context.abrupt('break', 29);
                        case 25:
                            msg = '错误消息\uFF1A' + json.error;
                            Message.error(msg);
                            _this.isPrinting = false;
                            return _context.abrupt('break', 29);
                        case 29:
                            if (!(status == 1000)) {
                                _context.next = 52;
                                break;
                            }
                            deviceInfo = {
                                'device_type': json.data.device.device_name || '',
                                'device_name': json.data.device.device_name || '',
                                'device_mac': json.data.device.device_mac || '',
                                'device_sn': json.data.device.device_sn || '',
                                'device_version': json.data.device.device_version || ''
                            };
                            appInfo = getAppInfo();
                            if (!(appInfo === null)) {
                                _context.next = 35;
                                break;
                            }
                            Message.error('获取不到学习机信息');
                            return _context.abrupt('return');
                        case 35:
                            _context.prev = 35;
                            postData = {
                                serial_num: _this.printSerialNnum,
                                app_info: appInfo,
                                device_info: JSON.stringify(deviceInfo),
                                content: JSON.stringify(_this.sendContent)
                            };
                            postData.timestamp = getStamp();
                            postData.rand = getRandom(6);
                            postData.sign = getSign(postData, _this.printKey);
                            _context.next = 42;
                            return api.savePrintInfo(_this.printHost, postData);
                        case 42:
                            result = _context.sent;
                            console.log(result, 'savePrintInfo');
                            if (result.code == 200) {
                                _this.hidePrinterSetDialog();
                                _this.goBack();
                            } else {
                                Message.error(result.msg);
                            }
                            _context.next = 50;
                            break;
                        case 47:
                            _context.prev = 47;
                            _context.t1 = _context['catch'](35);
                            console.log(_context.t1);
                        case 50:
                            Message.success(msg);
                            setTimeout(function () {
                                _this.closePreviewReport();
                            }, 2000);
                        case 52:
                        case 'end':
                            return _context.stop();
                        }
                    }
                }, _callee, null, [[
                        35,
                        47
                    ]]);
            }));
            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();
        this.fn = callback;
        SpadPrint.setInstance(this);
        this.init();
    }
    _createClass(SpadPrint, [
        {
            key: 'getEnv',
            value: function getEnv() {
                var env = 'PROD';
                var url = location.href;
                if (url.indexOf('spad.test') > -1 || url.indexOf('spad-test') > -1 || url.indexOf('report-test') > -1) {
                    env = 'TEST';
                } else if (url.indexOf('spad-pre') > -1 || url.indexOf('report-pre') > -1) {
                    env = 'PRE';
                }
                return env;
            }
        },
        {
            key: 'showSearchPrinterDialog',
            value: function showSearchPrinterDialog() {
                document.getElementById('searchPrinterDialog').style.display = 'block';
            }
        },
        {
            key: 'hideSearchPrinterDialog',
            value: function hideSearchPrinterDialog() {
                var dialog = document.getElementById('searchPrinterDialog');
                if (dialog) {
                    dialog.style.display = 'none';
                }
            }
        },
        {
            key: 'addSearchPrinter',
            value: function addSearchPrinter() {
                var machineType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'A4';
                var machineSN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var div = document.createElement('div');
                div.className = 'searchPrinterWrapper';
                div.setAttribute('id', 'searchPrinterDialog');
                this.hidePrinterSetDialog();
                var searchPrinterDialog = document.getElementById('searchPrinterDialog');
                if (searchPrinterDialog) {
                    this.showSearchPrinterDialog();
                    return;
                }
                window.document.body.appendChild(div);
                var printerImage;
                var machineDesc = '';
                if (machineType == 'A4') {
                    printerImage = '//cdn.classba.cn/public/spadPrint/images/A4Printer.png';
                    machineDesc = 'G40';
                } else {
                    printerImage = '//cdn.classba.cn/public/spadPrint/images/A9Printer.png';
                    machineDesc = 'G10';
                }
                div.innerHTML = '<div class="printerDialog"><img class="closeDialog" onclick="hideSearchPrinterDialog()" src="//cdn.classba.cn/public/spadPrint/images/close.png" /><div class="findPrinter" ><div><h3>连接成功</h3><dl><dt>松鼠Ai错题打印机'.concat(machineDesc, '</dt><dd>S/N\uFF1A').concat(machineSN, '</dd></dl></div><div style="height:245px" ><img  src="').concat(printerImage, '" /></div><div><p><button type="button" onclick="doPrint()">去打印</button></p></div><div></div></div></div>');
            }
        },
        {
            key: 'hidePreviewReportDialog',
            value: function hidePreviewReportDialog() {
                var dialog = document.getElementById('previewReoprtDialog');
                if (dialog) {
                    dialog.style.display = 'none';
                }
            }
        },
        {
            key: 'showPreviewReportDialog',
            value: function showPreviewReportDialog() {
                var dialog = document.getElementById('previewReoprtDialog');
                if (dialog) {
                    var app = document.getElementById('app');
                    if (app.style.display != 'none') {
                        app.style.display = 'none';
                    }
                    dialog.style.display = 'block';
                    return;
                }
                var div = document.createElement('div');
                div.className = 'previewReoprtWrapper';
                div.id = 'previewReoprtDialog';
                div.style.height = document.body.scrollHeight + 'px';
                window.document.body.appendChild(div);
                div.innerHTML = '<div  id="previewReoprt"><header class="printerHeader"><ul><li onclick="goBack()"><img style="width:50px;height:50px" src="https://cdn.classba.cn/public/spadPrint/images/return.png"/></li></ul><h3>预览</h3><ul><li onclick="showPrint()"><img  src="data:image/png;base64,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"></li></ul></header><div id="previewReoprtIframeWrapper" ><iframe id="previewReoprtIframe"  width="100%" height="100%" src=""/></div></div>';
                var src = location.href;
                var _char = '&';
                if (src.indexOf('?') == -1) {
                    _char = '?';
                }
                src += _char + 'printPageSize=A4';
                var previewReoprtIframe = document.getElementById('previewReoprtIframe');
                previewReoprtIframe.src = src;
                previewReoprtIframe.onload = function () {
                    previewReoprtIframe.style.display = 'block';
                    setTimeout(function () {
                        var songPrintApp = previewReoprtIframe.contentDocument.getElementById('app');
                        songPrintApp.style.height = 'auto';
                        var height = songPrintApp.scrollHeight;
                        var dialog = document.getElementById('previewReoprtDialog');
                        dialog.className = 'previewReoprtLoaded';
                        dialog.style.height = height + 'px';
                        previewReoprtIframe.height = height;
                        var app = document.getElementById('app');
                        if (app) {
                            app.style.display = 'none';
                        }
                        console.log(previewReoprtIframe.height, 'previewReoprtIframe.height');
                    }, 1000);
                };
            }
        },
        {
            key: 'checkAuthorization',
            value: function checkAuthorization() {
                var _this2 = this;
                if (this.isCheckingAuthorization) {
                    console.log('正在检查授权中\uFF0C忽略重复点击');
                    return;
                }
                console.log('检查打印授权');
                this.isCheckingAuthorization = true;
                if (this.authCheckTimerId) {
                    clearTimeout(this.authCheckTimerId);
                    this.authCheckTimerId = null;
                }
                jsBridgeForSSAI('isAuthorization', {}, 'authorizationResult');
                this.authCheckTimerId = setTimeout(function () {
                    if (_this2.isCheckingAuthorization) {
                        console.warn('授权检查超时\uFF0C授权协议不存在\uFF0C继续打印流程');
                        _this2.isCheckingAuthorization = false;
                        _this2.authCheckTimerId = null;
                        _this2.showPrinterSet();
                    }
                }, 2000);
            }
        },
        {
            key: 'showAuthorizationDialog',
            value: function showAuthorizationDialog() {
                var authDialog = document.getElementById('authorizationDialog');
                if (authDialog) {
                    authDialog.style.display = 'block';
                    return;
                }
                var div = document.createElement('div');
                div.className = 'authorizationWrapper';
                div.id = 'authorizationDialog';
                window.document.body.appendChild(div);
                div.innerHTML = '<div class="printerDialog"><h3 class="auth-title">授权提示</h3><div class="auth-content"><p class="auth-content-text">为完成蓝牙打印机的连接与配对\uFF0C需获取以下 2 项权限\uFF0C仅用于打印机相关操作\uFF1A</p><ul class="auth-content-list"><li><span class="auth-content-title">蓝牙权限\uFF1A</span><span class="auth-content-text">用于连接您的蓝牙打印机</span></li><li><span class="auth-content-title">相机权限\uFF1A</span><span class="auth-content-text">用于扫描打印机机身或说明书上的 "配对二维码"\uFF0C快速完成设备绑定</span></li></ul></div><div class="auth-footer"><button type="button" class="no-agree-button" onclick="handleAuthorizationDisagree()">暂不同意</button><button type="button" class="agree-button" onclick="handleAuthorizationAgree()">同意</button></div></div>';
            }
        },
        {
            key: 'hideAuthorizationDialog',
            value: function hideAuthorizationDialog() {
                var authDialog = document.getElementById('authorizationDialog');
                if (authDialog) {
                    authDialog.style.display = 'none';
                }
                this.isCheckingAuthorization = false;
            }
        },
        {
            key: 'handleAuthorization',
            value: function handleAuthorization(agree) {
                var _this3 = this;
                console.log('处理授权结果:', agree);
                jsBridgeForSSAI('agreeAuthorization', { agree: agree }, '');
                setTimeout(function () {
                    _this3.hideAuthorizationDialog();
                    if (agree) {
                        _this3.showPrinterSet();
                    }
                }, 100);
            }
        },
        {
            key: 'showPrinterSet',
            value: function () {
                var _showPrinterSet = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
                    var send_email_status, printerSetDialog, div;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                            case 0:
                                send_email_status = sessionStorage.getItem('send_email_status');
                                if (!(send_email_status == 1)) {
                                    _context2.next = 14;
                                    break;
                                }
                                this.loadingInstance && this.loadingInstance.close();
                                printerSetDialog = document.getElementById('printerSetDialog');
                                if (!printerSetDialog) {
                                    _context2.next = 7;
                                    break;
                                }
                                this.showPrinterSetDialog();
                                return _context2.abrupt('return');
                            case 7:
                                div = document.createElement('div');
                                div.className = 'showPrinterSetWrapper';
                                div.id = 'printerSetDialog';
                                window.document.body.appendChild(div);
                                div.innerHTML = '<div class="printerDialog"><img class="closeDialog" onclick="closeDialog()" src="//cdn.classba.cn/public/spadPrint/images/close.png" /><div class="btnClass"  id="btnShow" ><div onclick="doPrint()"><img width="30px" src="//cdn.classba.cn/public/spadPrint/images/printer.png" /><span>松鼠Ai打印机打印</span></div><div onclick="showSendEmail()"><img width="30px" src="//cdn.classba.cn/public/spadPrint/images/pdf.png" /><span>生成PDF发送至邮箱</span></div></div><div class="mail flexColumn" id="emailContent"  ><div></div><div><dl class="flexColumn"><dt class="flex"><img src="//cdn.classba.cn/public/spadPrint/images/mail.png" /> <span>邮箱\uFF1A</span></dt><dd><input type="text" id="email" placeholder="请输入邮箱地址" /></dd></dl></div><div><button type="button" onclick="sendMail()">发送</button></div></div></div>';
                                _context2.next = 15;
                                break;
                            case 14:
                                this.doPrint();
                            case 15:
                            case 'end':
                                return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
                function showPrinterSet() {
                    return _showPrinterSet.apply(this, arguments);
                }
                return showPrinterSet;
            }()
        },
        {
            key: 'hideSuccessDialog',
            value: function hideSuccessDialog() {
                var dialog = document.getElementById('successDialog');
                if (dialog) {
                    dialog.style.display = 'none';
                }
            }
        },
        {
            key: 'showSuccessDialog',
            value: function showSuccessDialog() {
                var dialog = document.getElementById('successDialog');
                if (dialog) {
                    dialog.style.display = 'block';
                    return;
                }
                var div = document.createElement('div');
                div.id = 'successDialog';
                window.document.body.appendChild(div);
                div.innerHTML = '<div class="printerDialog"><img class="closeDialog" onclick="hideSuccessDialog()" src="//cdn.classba.cn/public/spadPrint/images/close.png" /><img style="width:200px;height:200px"  src="//cdn.classba.cn/public/spadPrint/images/successIcon.png" /><p>邮件已发送!</p></div>';
            }
        },
        {
            key: 'hidePrinterSetDialog',
            value: function hidePrinterSetDialog() {
                var printerSetDialog = document.getElementById('printerSetDialog');
                if (printerSetDialog) {
                    printerSetDialog.style.display = 'none';
                }
            }
        },
        {
            key: 'goBack',
            value: function goBack() {
                document.getElementById('previewReoprtDialog').style.display = 'none';
                var app = document.getElementById('app');
                if (app) {
                    app.style.display = 'block';
                }
            }
        },
        {
            key: 'showSendEmail',
            value: function showSendEmail() {
                document.getElementById('btnShow').style.display = 'none';
                document.getElementById('emailContent').style.display = 'flex';
            }
        },
        {
            key: 'showPrinterSetDialog',
            value: function showPrinterSetDialog() {
                document.getElementById('printerSetDialog').style.display = 'block';
                document.getElementById('btnShow').style.display = 'flex';
                document.getElementById('emailContent').style.display = 'none';
            }
        },
        {
            key: 'init',
            value: function () {
                var _init = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                            case 0:
                                if (isSSAI()) {
                                    this.showPrintBtn();
                                }
                            case 1:
                            case 'end':
                                return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));
                function init() {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: 'showPrintBtn',
            value: function () {
                var _showPrintBtn = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
                    var account_id, appInfo, postData, result, songShuPrinterBtn;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(location.href.indexOf('printPageSize') > -1)) {
                                    _context4.next = 2;
                                    break;
                                }
                                return _context4.abrupt('return');
                            case 2:
                                account_id = this.options.accountId;
                                appInfo = getAppInfo();
                                appInfo = JSON.parse(appInfo);
                                if (appInfo && appInfo.app_version_code) {
                                    _context4.next = 8;
                                    break;
                                }
                                Message.error('app_version 未知');
                                return _context4.abrupt('return');
                            case 8:
                                postData = {
                                    'account_id': account_id,
                                    'app_version_code': appInfo.app_version_code
                                };
                                postData.timestamp = getStamp();
                                postData.rand = getRandom(6);
                                postData.sign = getSign(postData, this.printKey);
                                _context4.next = 14;
                                return api.checkPermission(this.printHost, postData);
                            case 14:
                                result = _context4.sent;
                                if (result.code == 200) {
                                    if (result.data && result.data.print_status == 1) {
                                        songShuPrinterBtn = document.getElementsByClassName('songShuPrinterBtn')[0];
                                        if (songShuPrinterBtn) {
                                            songShuPrinterBtn.style.display = 'block';
                                        }
                                        sessionStorage.setItem('send_email_status', result.data.send_email_status);
                                    }
                                } else {
                                    Message.error(result.msg);
                                }
                            case 16:
                            case 'end':
                                return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));
                function showPrintBtn() {
                    return _showPrintBtn.apply(this, arguments);
                }
                return showPrintBtn;
            }()
        },
        {
            key: 'wakeUpPrinterApp',
            value: function wakeUpPrinterApp(file_url, machine_type) {
                var fileUrls = [];
                if (file_url) {
                    fileUrls.push(file_url);
                }
                var params = {
                    machineType: machine_type,
                    fileUrls: fileUrls,
                    changeFile: this.changeFile
                };
                console.log(params, 'wakeUpPrinterApp');
                jsBridgeForSSAI('printer', params, 'printResult');
            }
        },
        {
            key: 'doPrint',
            value: function () {
                var _doPrint = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5() {
                    var printerDeviceInfo, appInfo, account_id, printType, is_async, machineType, _postData, latestPrintInfoResult, url, _char2, postData, result, machine_type;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!this.isPrinting) {
                                    _context5.next = 3;
                                    break;
                                }
                                console.log('正在打印中\uFF0C忽略重复点击');
                                return _context5.abrupt('return');
                            case 3:
                                console.log('开始打印流程');
                                this.isPrinting = true;
                                printerDeviceInfo = localStorage.getItem('printerDeviceInfo');
                                console.dir(printerDeviceInfo, 'printerDeviceInfo');
                                if (!printerDeviceInfo) {
                                    console.log(printerDeviceInfo, '获取不到打印机信息');
                                }
                                if (printerDeviceInfo == null) {
                                    printerDeviceInfo = '';
                                }
                                appInfo = getAppInfo();
                                if (!(appInfo === null)) {
                                    _context5.next = 14;
                                    break;
                                }
                                Message.error('获取不到学习机信息');
                                this.isPrinting = false;
                                return _context5.abrupt('return');
                            case 14:
                                _context5.prev = 14;
                                this.loadingInstance = Loading.service({
                                    lock: true,
                                    text: 'loading',
                                    spinner: 'el-icon-loading',
                                    background: 'rgba(0, 0, 0, 0.7)'
                                });
                                account_id = this.options.accountId;
                                printType = this.options.printType;
                                is_async = 1;
                                machineType = localStorage.getItem('machineType');
                                if (!(machineType == null)) {
                                    _context5.next = 47;
                                    break;
                                }
                                console.log(machineType, 'machineType为空');
                                machineType = '';
                                _postData = { 'account_id': account_id };
                                _postData.timestamp = getStamp();
                                _postData.rand = getRandom(6);
                                _postData.sign = getSign(_postData, this.printKey);
                                _context5.next = 29;
                                return api.latestPrintInfo(this.printHost, _postData);
                            case 29:
                                latestPrintInfoResult = _context5.sent;
                                console.log(latestPrintInfoResult, 'latestPrintInfo');
                                if (!(latestPrintInfoResult.code == 200)) {
                                    _context5.next = 43;
                                    break;
                                }
                                if (!(latestPrintInfoResult.data && latestPrintInfoResult.data.machine_type)) {
                                    _context5.next = 37;
                                    break;
                                }
                                machineType = latestPrintInfoResult.data.machine_type;
                                printerDeviceInfo = latestPrintInfoResult.data.device_info;
                                _context5.next = 41;
                                break;
                            case 37:
                                this.wakeUpPrinterApp('', '');
                                this.loadingInstance && this.loadingInstance.close();
                                this.isPrinting = false;
                                return _context5.abrupt('return');
                            case 41:
                                _context5.next = 47;
                                break;
                            case 43:
                                Message.error(latestPrintInfoResult.msg);
                                this.loadingInstance && this.loadingInstance.close();
                                this.isPrinting = false;
                                return _context5.abrupt('return');
                            case 47:
                                url = this.printUrl;
                                if (url.indexOf('?') == -1) {
                                    _char2 = '?';
                                } else {
                                    _char2 = '&';
                                }
                                if (machineType == 'A9') {
                                    url = url + _char2 + 'printPageSize=A9';
                                } else if (machineType == 'A4') {
                                    url = url + _char2 + 'printPageSize=A4';
                                } else {
                                    url = url + _char2 + 'printPageSize=A4';
                                    console.error('找不到打印机类型,默认A4\uFF01' + machineType);
                                }
                                postData = {
                                    'account_id': account_id,
                                    'type': printType,
                                    'url': url,
                                    'subject_id': this.options.subjectId,
                                    'app_info': appInfo,
                                    'device_info': printerDeviceInfo,
                                    'content': JSON.stringify(this.sendContent),
                                    'machine_type': machineType,
                                    is_async: is_async
                                };
                                postData.timestamp = getStamp();
                                postData.rand = getRandom(6);
                                postData.sign = getSign(postData, this.printKey);
                                _context5.next = 56;
                                return api.html2pdf(this.printHost, postData);
                            case 56:
                                result = _context5.sent;
                                if (result.code == 200) {
                                    if (result.data && result.data.serial_num) {
                                        this.printSerialNnum = result.data.serial_num;
                                        machine_type = result.data.machine_type;
                                        if (machine_type == 'A4' || machine_type == 'A9') {
                                            this.getPdfStatus(this.printSerialNnum, machine_type);
                                        } else {
                                            Message.error('打印机类型不匹配' + machine_type);
                                            this.loadingInstance && this.loadingInstance.close();
                                            this.isPrinting = false;
                                        }
                                    } else {
                                        this.loadingInstance && this.loadingInstance.close();
                                        this.wakeUpPrinterApp('', '');
                                        this.isPrinting = false;
                                    }
                                } else {
                                    Message.error(result.msg);
                                    this.loadingInstance && this.loadingInstance.close();
                                    this.isPrinting = false;
                                }
                                _context5.next = 65;
                                break;
                            case 60:
                                _context5.prev = 60;
                                _context5.t0 = _context5['catch'](14);
                                console.log(_context5.t0, 'printError');
                                this.loadingInstance && this.loadingInstance.close();
                                this.isPrinting = false;
                            case 65:
                            case 'end':
                                return _context5.stop();
                            }
                        }
                    }, _callee5, this, [[
                            14,
                            60
                        ]]);
                }));
                function doPrint() {
                    return _doPrint.apply(this, arguments);
                }
                return doPrint;
            }()
        },
        {
            key: 'getPdfStatus',
            value: function () {
                var _getPdfStatus = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6(serial_num, machine_type) {
                    var _this4 = this;
                    var timestamp, rand, postData, sign, infoResult, file_url;
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                            switch (_context6.prev = _context6.next) {
                            case 0:
                                timestamp = getStamp();
                                rand = getRandom(6);
                                postData = {
                                    serial_num: serial_num,
                                    rand: rand,
                                    timestamp: timestamp
                                };
                                sign = getSign(postData, this.printKey);
                                postData.sign = sign;
                                _context6.next = 7;
                                return api.html2pdfInfo(this.printHost, postData);
                            case 7:
                                infoResult = _context6.sent;
                                if (!(infoResult.code == 200)) {
                                    _context6.next = 17;
                                    break;
                                }
                                if (!(infoResult.data.print_status == 0)) {
                                    _context6.next = 12;
                                    break;
                                }
                                setTimeout(function () {
                                    _this4.getPdfStatus(serial_num, machine_type);
                                }, 2000);
                                return _context6.abrupt('return');
                            case 12:
                                file_url = infoResult.data.file_url;
                                this.loadingInstance && this.loadingInstance.close();
                                this.wakeUpPrinterApp(file_url, machine_type);
                                _context6.next = 20;
                                break;
                            case 17:
                                Message.error(infoResult.msg);
                                this.loadingInstance && this.loadingInstance.close();
                                this.isPrinting = false;
                            case 20:
                            case 'end':
                                return _context6.stop();
                            }
                        }
                    }, _callee6, this);
                }));
                function getPdfStatus(_x2, _x3) {
                    return _getPdfStatus.apply(this, arguments);
                }
                return getPdfStatus;
            }()
        },
        {
            key: 'closePreviewReport',
            value: function closePreviewReport() {
                this.hidePreviewReportDialog();
                this.hidePrinterSetDialog();
                this.hideSuccessDialog();
                this.hideSearchPrinterDialog();
                this.hideAuthorizationDialog();
                this.isCheckingAuthorization = false;
                this.isPrinting = false;
            }
        },
        {
            key: 'sendMail',
            value: function () {
                var _sendMail = _asyncToGenerator(_regeneratorRuntime.mark(function _callee7() {
                    var _this5 = this;
                    var email, appInfo, account_id, url, printType, is_async, timestamp, rand, subject_id, postData, sign, result;
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                            switch (_context7.prev = _context7.next) {
                            case 0:
                                email = document.getElementById('email').value;
                                if (validateEmail(email)) {
                                    _context7.next = 4;
                                    break;
                                }
                                Message.error('输入有误\uFF0C请再次核对');
                                return _context7.abrupt('return');
                            case 4:
                                appInfo = getAppInfo();
                                if (!(appInfo === null)) {
                                    _context7.next = 8;
                                    break;
                                }
                                Message.error('获取不到学习机信息');
                                return _context7.abrupt('return');
                            case 8:
                                _context7.prev = 8;
                                this.loadingInstance = Loading.service({
                                    lock: true,
                                    text: 'loading',
                                    spinner: 'el-icon-loading',
                                    background: 'rgba(0, 0, 0, 0.7)'
                                });
                                account_id = this.options.accountId;
                                url = this.printUrl + '&printPageSize=A4';
                                printType = this.options.printType;
                                is_async = 1;
                                timestamp = getStamp();
                                rand = getRandom(6);
                                subject_id = this.options.subjectId;
                                postData = {
                                    account_id: account_id,
                                    type: printType,
                                    url: url,
                                    email: email,
                                    rand: rand,
                                    subject_id: subject_id,
                                    timestamp: timestamp,
                                    is_async: is_async,
                                    content: JSON.stringify(this.sendContent),
                                    app_info: appInfo
                                };
                                sign = getSign(postData, this.printKey);
                                postData.sign = sign;
                                _context7.next = 22;
                                return api.html2pdf2email(this.printHost, postData);
                            case 22:
                                result = _context7.sent;
                                if (result.code == 200) {
                                    this.hidePrinterSetDialog();
                                    this.showSuccessDialog();
                                    setTimeout(function () {
                                        _this5.closePreviewReport();
                                        _this5.goBack();
                                    }, 2000);
                                } else {
                                    Message.error(result.msg);
                                }
                                _context7.next = 30;
                                break;
                            case 26:
                                _context7.prev = 26;
                                _context7.t0 = _context7['catch'](8);
                                console.log(_context7.t0, '邮件发送失败');
                                Message.error('邮件发送失败');
                            case 30:
                                this.loadingInstance && this.loadingInstance.close();
                            case 31:
                            case 'end':
                                return _context7.stop();
                            }
                        }
                    }, _callee7, this, [[
                            8,
                            26
                        ]]);
                }));
                function sendMail() {
                    return _sendMail.apply(this, arguments);
                }
                return sendMail;
            }()
        }
    ]);
    return SpadPrint;
}();
export default SpadPrint;
var spadPrintInstance = null;
SpadPrint.setInstance = function (instance) {
    spadPrintInstance = instance;
};
window.showPrint = function () {
    if (spadPrintInstance) {
        spadPrintInstance.checkAuthorization();
    }
};
window.doPrint = function () {
    if (spadPrintInstance) {
        spadPrintInstance.doPrint();
    }
};
window.closeDialog = function () {
    if (spadPrintInstance) {
        spadPrintInstance.hidePrinterSetDialog();
    }
};
window.showSendEmail = function () {
    if (spadPrintInstance) {
        spadPrintInstance.showSendEmail();
    }
};
window.sendMail = function () {
    if (spadPrintInstance) {
        spadPrintInstance.sendMail();
    }
};
window.goBack = function () {
    if (spadPrintInstance) {
        spadPrintInstance.goBack();
    }
};
window.hideSuccessDialog = function () {
    if (spadPrintInstance) {
        spadPrintInstance.hideSuccessDialog();
    }
};
window.hideSearchPrinterDialog = function () {
    if (spadPrintInstance) {
        spadPrintInstance.hideSearchPrinterDialog();
    }
};
window.showPreviewReportDialog = function (options) {
    if (options) {
        spadPrintInstance = new SpadPrint(options);
        SpadPrint.setInstance(spadPrintInstance);
    }
    if (spadPrintInstance) {
        spadPrintInstance.showPreviewReportDialog();
    }
};
window.handleAuthorizationAgree = function () {
    if (spadPrintInstance) {
        spadPrintInstance.handleAuthorization(true);
    }
};
window.handleAuthorizationDisagree = function () {
    if (spadPrintInstance) {
        spadPrintInstance.handleAuthorization(false);
    }
};